import React from 'react'
import Image from '../Image'
import { useLocation } from '@reach/router'

import {
  Paragraph,
  Blockquote,
  InlineCode,
  Strong,
  A,
  H1Error,
  H2,
  H3,
  H4,
  H5,
  Hr,
  Li,
  Ol,
  Ul,
  Table,
  TH,
  TD,
  TableWrapper,
  WideImage,
} from '../styles'
import Pre from '../Code/Pre'
import Button from '../../../shared/Button'
import Collapse from '../Collapse'
import CommunityContribution from '../CommunityContribution'
import CompaniesUsingPrisma from '../CompaniesUsingPrisma'
import Emphasis from '../Emphasis'
import Glitch from '../Glitch'
import HEXColor from '../HEXColor'
import MasonryWall from '../MasonryWall'
import PrismaWithX from '../PrismaWithX'
import Quotes from '../Quotes'
import RecentPosts from '../RecentPosts'
import TweetEmbed from '../TweetEmbed'
import Video from '../Video'
import Youtube from '../Youtube'
import UsingCompany, { UsingCompanyListCarousel } from '../CompaniesUsingPrisma'
import Code from '../Code/Panel'
import { pathsForUTMOverride } from '../../../../constants'

const TableElement = ({ ...props }: any) => (
  <TableWrapper>
    <Table>{props.children}</Table>
  </TableWrapper>
)

const AnchorElement = ({ href, ...props }: any) => {
  const location = useLocation()
  const utmParamsPresent = location.search !== ''
  const urlWithoutQueryParam = href?.split('?')[0]

  return (
    <A
      href={
        utmParamsPresent && pathsForUTMOverride.some((url) => urlWithoutQueryParam?.includes(url))
          ? urlWithoutQueryParam + location.search
          : href
      }
      {...props}
    />
  )
}

const components = {
  h1: H1Error,
  h2: H2,
  h3: H3,
  h4: H4,
  h5: H5,
  h6: H5,
  hr: Hr,
  p: Paragraph,
  a: AnchorElement,
  pre: Pre,
  code: InlineCode,
  blockquote: Blockquote,
  ol: Ol,
  ul: Ul,
  li: Li,
  strong: Strong,
  inlineCode: InlineCode,
  img: Image,
  table: TableElement,
  th: TH,
  td: TD,
  Abstract: () => <></>,
  Button,
  Collapse,
  CommunityContribution,
  CompaniesUsingPrisma,
  Emphasis,
  Glitch,
  HEXColor,
  Image,
  MasonryWall,
  PrismaWithX,
  Quotes,
  RecentPosts,
  TweetEmbed,
  Video,
  Youtube,
  UsingCompany,
  UsingCompanyListCarousel,
  Code,
  WideImage,
}

export default components
